
const imageUrl =process.env.REACT_APP_FILE_BASE_URL

export const ImageLink = (name) => {
    return `${imageUrl}${name}`;
};
